/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Ajouter"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Supprimer tout"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var frCA = Object.assign(TranslationProviderComponent, {
  translations
});

export { frCA as f };
//# sourceMappingURL=fr-CA-DsQSz1XU.js.map
